import React, { useState, useEffect, Component } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ClipLoader } from 'react-spinners';
import { toast } from "react-toastify";
import * as XLSX from "xlsx-js-style";
import jsPDF from "jspdf";
import "jspdf-autotable";

const AgentDetailReport = () => {
    const apiService = new LeaseApiService();
    const [rowData, setRowData] = useState([]);
    const [agentData, setAgentData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [detailsTab, setDetailsTab] = useState(false);
    const [directTab, setDIrectTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [type, setType] = useState([]);
    const [leaseType, setLeaseType] = useState([]);
    const [reason, setReason] = useState([]);
    const [classList, setClassList] = useState([]);
    const [source, setSource] = useState([]);

    const [formData, setFormData] = useState({
        property: "",
        type: "",
        leaseType: "",
        reason: "",
        class: "",
        source: "",
        from: "",
        to: "",
    })

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };

    useEffect(() => {
        fetchDropdownData()
        const today = new Date();
        let todate = formatDate(today)
        setFormData((prev) => ({ ...prev, to: todate, from: todate }));
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRSearchPropertyNos,LRAgentDirectSearchLeaseType,LRAgreeSearchType,LRAgreeSearchReason,LRNAgentDetailSearchUnitClass,LRNAgentDetailSearchUnitSource');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            setPropertyList(res?.data?.dropdowns?.PropertyNo)
            setLeaseType(res?.data?.dropdowns?.LRAgentDirectSearchLeaseType)
            setType(res?.data?.dropdowns?.LRAgreeSearchType)
            setReason(res?.data?.dropdowns?.LRAgreeSearchReason)
            setClassList(res?.data?.dropdowns?.LRNAgentDetailSearchUnitClass)
            setSource(res?.data?.dropdowns?.LRNAgentDetailSearchUnitSource)

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            params.append("FromDate", formData?.from || todate);
            params.append("ToDate", formData?.to || todate);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            params.append("LeaseType", formData?.leaseType?.label || "All");
            params.append("Type", formData?.type?.label || "All");
            params.append("Reason", formData?.reason?.label || "All");
            params.append("UnitClass", formData?.class?.label || "ALL");
            params.append("Source", formData?.source?.label || "All");
            const res = await apiService.getApiParamater("REPORT_AGENT_DETAIL", `?${params.toString()}`);
            if (res?.data?.result) {
                const data = res?.data?.result?.filter(acc => acc.agent !== "0");
                const agentData = res?.data?.result?.filter(acc => acc.agent === "0");
                setAgentData(data || [])
                setRowData(agentData || [])
                setPagination(res.data.paginationData)
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            setLoader(false)
            console.error("Error fetching items:", error);
            // Handle error (e.g., show error message to user)
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("FromDate", formData?.from || todate);
            params.append("ToDate", formData?.to || todate);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            params.append("LeaseType", formData?.leaseType?.label || "All");
            params.append("Type", formData?.type?.label || "All");
            params.append("Reason", formData?.reason?.label || "All");
            params.append("UnitClass", formData?.class?.label || "ALL");
            params.append("Source", formData?.source?.label || "All");
            const res = await apiService.getApiParamater("REPORT_AGENT_DETAIL", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                setExportData(result || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            // Handle error (e.g., show error message to user)
            console.error("Error fetching items:", error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const agentColumn = [
        { headerName: "S.No", field: "", filter: true, floatingFilter: true, suppressMovable: true, width: 100, valueGetter: (params) => params.node.rowIndex + 1, },
        { headerName: "Property", field: "property_Name", filter: true, floatingFilter: true, suppressMovable: true, width: 250, },
        { headerName: "Unit No", field: "unit_No", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        { headerName: "Bedroom", field: "bedroom", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Tenant Name", field: "cust1_Name", filter: true, floatingFilter: true, suppressMovable: true, width: 250, },
        { headerName: " Move In", field: "lease_Date", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: " Move Out", field: "lease_Expiry", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: " Move Out Status", field: "leaseStatus", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Source", field: "source", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Agent Name", field: "agent", filter: true, floatingFilter: true, suppressMovable: true, width: 250, },
        {
            headerName: "Rent", field: "rent", filter: true, floatingFilter: true, suppressMovable: true, width: 100,
            valueFormatter: (params) => (parseFloat(params.value) || 0).toFixed(3),
        },
    ]
    const directColumn = [
        { headerName: "S.No", field: "", filter: true, floatingFilter: true, suppressMovable: true, width: 100, valueGetter: (params) => params.node.rowIndex + 1, },
        { headerName: "Property", field: "property_Name", filter: true, floatingFilter: true, suppressMovable: true, width: 250, },
        { headerName: "Unit No", field: "unit_No", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        { headerName: "Bedroom", field: "bedroom", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Tenant Name", field: "cust1_Name", filter: true, floatingFilter: true, suppressMovable: true, width: 250, },
        { headerName: " Move In", field: "lease_Date", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: " Move Out", field: "lease_Expiry", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: " Move Out Status", field: "leaseStatus", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Source", field: "source", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        {
            headerName: "Rent", field: "rent", filter: true, floatingFilter: true, suppressMovable: true, width: 100,
            valueFormatter: (params) => (parseFloat(params.value) || 0).toFixed(3),
        },
    ]
    const handleClearFilters = () => {
        const today = new Date();
        let todate = formatDate(today)
        setFormData({
            property: "",
            type: "",
            leaseType: "",
            reason: "",
            class: "",
            source: "",
            from: todate,
            to: todate,
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";

        // Keep 0 as empty if required
        if (value === 0 || value === "0") return "";

        return value;
    };
    const exportExcel = () => {
        if (!exportData || !Array.isArray(exportData) || exportData.length === 0) {
            console.warn("No export data available");
            return;
        }

        // =========================================================
        // SPLIT DATA
        // =========================================================

        const agentData = exportData.filter(
            (item) => item?.agent !== "0"
        );

        const directData = exportData.filter(
            (item) => item?.agent === "0"
        );

        // =========================================================
        // AGENT COLUMNS
        // =========================================================

        const agentColumns = [
            {
                header: "S. No",
                dataKey: "sno",
                width: 10,
            },
            {
                header: "Property",
                dataKey: "property_Name",
                width: 28,
            },
            {
                header: "Unit No",
                dataKey: "unit_No",
                width: 15,
            },
            {
                header: "Bedroom",
                dataKey: "bedroom",
                width: 14,
            },
            {
                header: "Tenant Name",
                dataKey: "cust1_Name",
                width: 35,
            },
            {
                header: "Move In",
                dataKey: "lease_Date",
                width: 18,
            },
            {
                header: "Move Out",
                dataKey: "lease_Expiry",
                width: 18,
            },
            {
                header: "Move Out Status",
                dataKey: "leaseStatus",
                width: 22,
            },
            {
                header: "Source",
                dataKey: "source",
                width: 28,
            },
            {
                header: "Agent Name",
                dataKey: "agent",
                width: 35,
            },
            {
                header: "Rent",
                dataKey: "rent",
                width: 18,
            },
        ];

        // =========================================================
        // DIRECT COLUMNS
        // =========================================================

        const directColumns = [
            {
                header: "S. No",
                dataKey: "sno",
                width: 10,
            },
            {
                header: "Property",
                dataKey: "property_Name",
                width: 28,
            },
            {
                header: "Unit No",
                dataKey: "unit_No",
                width: 15,
            },
            {
                header: "Bedroom",
                dataKey: "bedroom",
                width: 14,
            },
            {
                header: "Tenant Name",
                dataKey: "cust1_Name",
                width: 35,
            },
            {
                header: "Move In",
                dataKey: "lease_Date",
                width: 18,
            },
            {
                header: "Move Out",
                dataKey: "lease_Expiry",
                width: 18,
            },
            {
                header: "Move Out Status",
                dataKey: "leaseStatus",
                width: 22,
            },
            {
                header: "Source",
                dataKey: "source",
                width: 28,
            },
            {
                header: "Rent",
                dataKey: "rent",
                width: 18,
            },
        ];

        // =========================================================
        // CREATE WORKBOOK
        // =========================================================

        const workbook = XLSX.utils.book_new();

        const worksheet = {};

        // =========================================================
        // EXCEL COLUMN HELPER
        // =========================================================

        const getExcelColumn = (colNumber) => {
            let column = "";

            while (colNumber >= 0) {
                column =
                    String.fromCharCode((colNumber % 26) + 65) +
                    column;

                colNumber =
                    Math.floor(colNumber / 26) - 1;
            }

            return column;
        };

        // =========================================================
        // CELL HELPER
        // =========================================================

        const setCell = (row, col, value) => {
            const address = `${getExcelColumn(col)}${row}`;

            worksheet[address] = {
                v: value,
                t: typeof value === "number" ? "n" : "s",
            };
        };

        // =========================================================
        // STYLES
        // MATCH REVENUE RENTAL REPORT
        // =========================================================

        // Main report title
        const titleStyle = {
            font: {
                name: "Calibri",
                sz: 18,
                bold: true,
                color: {
                    rgb: "FFFFFF",
                },
            },

            fill: {
                fgColor: {
                    rgb: "6E5199",
                },
            },

            alignment: {
                horizontal: "left",
                vertical: "center",
            },

            border: {
                top: {
                    style: "medium",
                    color: {
                        rgb: "6E5199",
                    },
                },
                bottom: {
                    style: "medium",
                    color: {
                        rgb: "6E5199",
                    },
                },
                left: {
                    style: "medium",
                    color: {
                        rgb: "6E5199",
                    },
                },
                right: {
                    style: "medium",
                    color: {
                        rgb: "6E5199",
                    },
                },
            },
        };

        // Section headings
        const sectionStyle = {
            font: {
                name: "Calibri",
                sz: 14,
                bold: true,
                color: {
                    rgb: "FFFFFF",
                },
            },

            // Revenue Rental primary purple
            fill: {
                fgColor: {
                    rgb: "6E5199",
                },
            },

            alignment: {
                horizontal: "center",
                vertical: "center",
            },

            border: {
                top: {
                    style: "medium",
                    color: {
                        rgb: "6E5199",
                    },
                },
                bottom: {
                    style: "medium",
                    color: {
                        rgb: "6E5199",
                    },
                },
                left: {
                    style: "medium",
                    color: {
                        rgb: "6E5199",
                    },
                },
                right: {
                    style: "medium",
                    color: {
                        rgb: "6E5199",
                    },
                },
            },
        };

        // Column headings
        const headerStyle = {
            font: {
                name: "Calibri",
                sz: 11,
                bold: true,
                color: {
                    rgb: "FFFFFF",
                },
            },

            fill: {
                fgColor: {
                    rgb: "666666",
                },
            },

            alignment: {
                horizontal: "center",
                vertical: "center",
                wrapText: true,
            },

            border: {
                top: {
                    style: "thin",
                    color: {
                        rgb: "B7B7B7",
                    },
                },
                bottom: {
                    style: "thin",
                    color: {
                        rgb: "B7B7B7",
                    },
                },
                left: {
                    style: "thin",
                    color: {
                        rgb: "B7B7B7",
                    },
                },
                right: {
                    style: "thin",
                    color: {
                        rgb: "B7B7B7",
                    },
                },
            },
        };

        // Data borders
        const dataBorder = {
            top: {
                style: "thin",
                color: {
                    rgb: "D9D9D9",
                },
            },

            bottom: {
                style: "thin",
                color: {
                    rgb: "D9D9D9",
                },
            },

            left: {
                style: "thin",
                color: {
                    rgb: "D9D9D9",
                },
            },

            right: {
                style: "thin",
                color: {
                    rgb: "D9D9D9",
                },
            },
        };

        // =========================================================
        // ADD MAIN TITLE
        // =========================================================

        let currentRow = 1;

        const totalColumns = Math.max(
            agentColumns.length,
            directColumns.length
        );

        const titleStartCol = 1; // B

        const titleEndCol =
            titleStartCol + totalColumns - 1;

        setCell(
            currentRow,
            titleStartCol,
            "AGENT DETAILS REPORT"
        );

        worksheet["!merges"] = [
            {
                s: {
                    r: currentRow - 1,
                    c: titleStartCol,
                },
                e: {
                    r: currentRow - 1,
                    c: titleEndCol,
                },
            },
        ];

        worksheet[
            `${getExcelColumn(titleStartCol)}${currentRow}`
        ].s = titleStyle;

        currentRow += 2;

        // =========================================================
        // CREATE SECTION
        // =========================================================

        const createSection = (
            title,
            data,
            columns,
            sectionRow
        ) => {

            // -----------------------------------------------------
            // SECTION TITLE
            // -----------------------------------------------------

            setCell(
                sectionRow,
                titleStartCol,
                title
            );

            const sectionEndCol =
                titleStartCol + columns.length - 1;

            worksheet["!merges"].push({
                s: {
                    r: sectionRow - 1,
                    c: titleStartCol,
                },
                e: {
                    r: sectionRow - 1,
                    c: sectionEndCol,
                },
            });

            worksheet[
                `${getExcelColumn(titleStartCol)}${sectionRow}`
            ].s = sectionStyle;

            // -----------------------------------------------------
            // HEADERS
            // -----------------------------------------------------

            const headerRow = sectionRow + 1;

            columns.forEach((column, index) => {

                setCell(
                    headerRow,
                    titleStartCol + index,
                    column.header
                );

                const address =
                    `${getExcelColumn(
                        titleStartCol + index
                    )}${headerRow}`;

                worksheet[address].s = headerStyle;
            });

            // -----------------------------------------------------
            // DATA
            // -----------------------------------------------------

            let dataRow = headerRow + 1;

            data.forEach((item, index) => {

                columns.forEach((column, columnIndex) => {

                    let value;

                    if (column.dataKey === "sno") {
                        value = index + 1;
                    } else if (column.dataKey === "rent") {
                        value = Number(item?.[column.dataKey]) || 0;
                    } else {
                        value = normalizeValue(
                            item?.[column.dataKey]
                        );
                    }

                    setCell(
                        dataRow,
                        titleStartCol + columnIndex,
                        value
                    );

                    const address =
                        `${getExcelColumn(
                            titleStartCol + columnIndex
                        )}${dataRow}`;

                    // -------------------------------------------------
                    // DATA STYLE
                    // -------------------------------------------------

                    worksheet[address].s = {
                        font: {
                            name: "Calibri",
                            sz: 10,
                        },

                        alignment: {
                            vertical: "center",

                            horizontal:
                                column.dataKey === "rent" ||
                                    column.dataKey === "sno" ||
                                    column.dataKey === "unit_No" ||
                                    column.dataKey === "bedroom"
                                    ? "center"
                                    : "left",

                            wrapText: true,
                        },

                        border: dataBorder,

                        // Same alternating background used
                        // by Revenue Rental Report
                        fill: {
                            fgColor: {
                                rgb:
                                    index % 2 === 0
                                        ? "FFFFFF"
                                        : "F5F2F8",
                            },
                        },
                    };

                    // -------------------------------------------------
                    // RENT FORMAT
                    // -------------------------------------------------

                    if (column.dataKey === "rent") {
                        worksheet[address].t = "n";
                        worksheet[address].z = "#,##0.000";
                    }
                });

                dataRow++;
            });

            // -----------------------------------------------------
            // TOTALS ROW
            // -----------------------------------------------------

            if (data.length > 0) {
                const totalRent = data.reduce(
                    (sum, item) => sum + (Number(item?.rent) || 0),
                    0
                );

                columns.forEach((column, columnIndex) => {
                    let value = "";

                    if (columnIndex === 0) {
                        value = "Total";
                    } else if (column.dataKey === "rent") {
                        value = totalRent;
                    }

                    setCell(
                        dataRow,
                        titleStartCol + columnIndex,
                        value
                    );

                    const address =
                        `${getExcelColumn(
                            titleStartCol + columnIndex
                        )}${dataRow}`;

                    worksheet[address].s = {
                        font: {
                            name: "Calibri",
                            sz: 10,
                            bold: true,
                        },

                        alignment: {
                            vertical: "center",
                            horizontal: column.dataKey === "rent" ? "center" : "left",
                            wrapText: true,
                        },

                        border: dataBorder,

                        fill: {
                            fgColor: {
                                rgb: "F0EDF5",
                            },
                        },
                    };

                    if (column.dataKey === "rent") {
                        worksheet[address].t = "n";
                        worksheet[address].z = "#,##0.000";
                    }
                });

                dataRow++;
            }

            return dataRow;
        };

        // =========================================================
        // AGENT SECTION
        // =========================================================

        currentRow = createSection(
            "AGENT DETAILS",
            agentData,
            agentColumns,
            currentRow
        );

        // =========================================================
        // SPACE BETWEEN SECTIONS
        // =========================================================

        currentRow += 2;

        // =========================================================
        // DIRECT SECTION
        // =========================================================

        currentRow = createSection(
            "DIRECT DETAILS",
            directData,
            directColumns,
            currentRow
        );

        // =========================================================
        // COLUMN WIDTHS
        // =========================================================

        worksheet["!cols"] = [];

        worksheet["!cols"][0] = {
            wch: 3,
        };

        agentColumns.forEach((column, index) => {

            worksheet["!cols"][titleStartCol + index] = {
                wch: column.width,
            };
        });

        // =========================================================
        // ROW HEIGHTS
        // =========================================================

        worksheet["!rows"] = [];

        // Main title
        worksheet["!rows"][0] = {
            hpt: 32,
        };

        // Section/header/data rows
        for (let i = 1; i < currentRow; i++) {
            if (!worksheet["!rows"][i]) {
                worksheet["!rows"][i] = {
                    hpt: 22,
                };
            }
        }

        // =========================================================
        // FREEZE PANES
        // =========================================================

        worksheet["!freeze"] = {
            xSplit: 1,
            ySplit: 4,
        };

        // =========================================================
        // AUTO FILTER
        // =========================================================

        if (agentData.length > 0) {

            worksheet["!autofilter"] = {
                ref: `B${4}:${getExcelColumn(
                    titleStartCol +
                    agentColumns.length -
                    1
                )}${3 + agentData.length}`,
            };
        }

        // =========================================================
        // FINAL RANGE
        // =========================================================

        worksheet["!ref"] =
            `B1:${getExcelColumn(
                titleStartCol + totalColumns - 1
            )}${currentRow}`;

        // =========================================================
        // ADD WORKSHEET
        // =========================================================

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Agent Details Report"
        );

        // =========================================================
        // EXPORT
        // =========================================================

        XLSX.writeFile(
            workbook,
            "Agent_Details_Report.xlsx",
            {
                cellStyles: true,
            }
        );
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain">
                            <div className=" d-flex">
                                <label className="form-label w-0">From Date</label>
                                <DatePicker
                                    selected={formData.from}
                                    onChange={(date) => handleDateChange({ name: 'from', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className=" d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className=" d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Type</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.type}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'type', value: selectedOption })}
                                    options={type?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className=" d-flex">
                                <label className="form-label w-0">To Date</label>
                                <DatePicker
                                    selected={formData.to}
                                    onChange={(date) => handleDateChange({ name: 'to', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className=" d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Lease Type</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.leaseType}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'leaseType', value: selectedOption })}
                                    options={leaseType?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className=" d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Termination Reason</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.reason}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'reason', value: selectedOption })}
                                    options={reason?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className=" d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Class</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.class}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'class', value: selectedOption })}
                                    options={classList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className=" d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Source</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.source}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'source', value: selectedOption })}
                                    options={source?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex gap-2">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-100'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div onClick={() => getItems()} className="mainbtnGry flex-end gap-2 w-100">
                                        <FaFileCircleExclamation color="#fff" className="center mt-2 mx-2" />
                                        <div className="center">Search</div>
                                    </div>
                                }
                                <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-100">
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="cost-center-section">
                            <div
                                className="d-flex mt-3 cursor-pointer slide-header justify-content-between"
                                onClick={() => setDetailsTab(!detailsTab)}
                            >
                                <div className="h6 pt-1">Agent</div>
                                <button className="btn btn-secondary mx-3 " onClick={exportExcel}>
                                    Export as Excel
                                </button>
                            </div>
                            <div className={`slide-content ${detailsTab ? "open" : "closed"}`}>
                                <div className={`border-box2  ${detailsTab ? "slide-in" : "slide-out"}`}>
                                    <div className="ag-theme-quartz" >
                                        <div style={{ height: 250 }}>
                                            <AgGridReact
                                                getRowStyle={(params) => {
                                                    if (params.node.rowIndex % 2 === 0) {
                                                        return { background: "#F0EDF5" };
                                                    } else {
                                                        return { background: "#fff" };
                                                    }
                                                }}
                                                rowData={agentData}
                                                enableFilter={true}
                                                floatingFilter={true}
                                                columnDefs={agentColumn}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="d-flex mt-3 cursor-pointer slide-header "
                                onClick={() => setDIrectTab(!directTab)}
                            >
                                <div className="h6 pt-1">Direct</div>
                            </div>
                            <div className={`slide-content ${directTab ? "open" : "closed"}`}>
                                <div className={`border-box2  ${directTab ? "slide-in" : "slide-out"}`}>
                                    <div className="ag-theme-quartz" >
                                        <div style={{ height: 300 }}>
                                            <AgGridReact
                                                getRowStyle={(params) => {
                                                    if (params.node.rowIndex % 2 === 0) {
                                                        return { background: "#F0EDF5" };
                                                    } else {
                                                        return { background: "#fff" };
                                                    }
                                                }}
                                                rowData={rowData}
                                                enableFilter={true}
                                                floatingFilter={true}
                                                columnDefs={directColumn}
                                            />
                                        </div>
                                        <Pagination
                                            pageSize={pageSize}
                                            setPageSize={setPageSize}
                                            pagination={pagination}
                                            getItems={getItems}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default AgentDetailReport;